import { RefObject, useEffect } from 'react';

type Props<T extends HTMLElement> = {
  ref: RefObject<T>;
  preventScroll?: boolean;
};

export const useAutoFocus = <T extends HTMLElement>({
  ref,
  preventScroll = false,
}: Props<T>) => {
  useEffect(() => {
    ref.current?.focus({ preventScroll });
  }, [preventScroll, ref]);
};
